import Vue from 'vue';
import {firestorePlugin} from 'vuefire';
import firebase from 'firebase/app';
import 'firebase/firestore';

Vue.use(firestorePlugin)

const firebaseApp = firebase.initializeApp({
  // ここにfirebaseのapi情報をコピペします。
  apiKey: "AIzaSyCF7V3DSYbTV3rbjoS5doIoSahh8y845aU",
  authDomain: "sharemotion-c0b74.firebaseapp.com",
  databaseURL: "https://sharemotion-c0b74.firebaseio.com",
  projectId: "sharemotion-c0b74",
  storageBucket: "sharemotion-c0b74.appspot.com",
  messagingSenderId: "488471227163",
  appId: "1:488471227163:web:b052c161aac0c3fb5e41be",
  measurementId: "G-RWWR0Q7ESP"

});

export const db = firebaseApp.firestore();
export default firebase;